export default __webpack_public_path__ + "static/media/web.f2ce5b99.svg";